import { FolderKanban } from "lucide-react";
import {
  FilterLiveForm,
  useGetList,
  useListContext,
  useTranslate,
} from "ra-core";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { SearchInput } from "@/components/admin/search-input";

import { FilterCategory } from "../filters/FilterCategory";
import type { CompanyFolder } from "../types";
import { CreateCompanyFolderButton } from "./CreateCompanyFolderButton";

export const CompanyListFilter = () => {
  const translate = useTranslate();
  const { filterValues } = useListContext();
  const { data: folders = [] } = useGetList<CompanyFolder>("company_lists", {
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });

  return (
    <div className="w-52 min-w-52 flex flex-col gap-8">
      <FilterLiveForm>
        <SearchInput source="q" />
      </FilterLiveForm>

      <CreateCompanyFolderButton />

      <FilterCategory
        icon={<FolderKanban className="h-4 w-4" />}
        label="resources.companies.folders.title"
      >
        {folders.length === 0 ? (
          <p className="text-xs text-muted-foreground px-1">
            {translate("resources.companies.folders.empty", {
              _: "Crea una carpeta (nicho + ciudad) y después importa el CSV.",
            })}
          </p>
        ) : (
          folders.map((folder) => (
            <ToggleFilterButton
              className="w-full justify-between"
              label={folder.name}
              key={folder.id}
              value={{ list_id: folder.id }}
            />
          ))
        )}
        {filterValues.list_id ? (
          <p className="text-xs text-muted-foreground px-1">
            {translate("resources.companies.folders.active_help", {
              _: "El CSV de esta carpeta hereda el sector y la zona.",
            })}
          </p>
        ) : null}
      </FilterCategory>
    </div>
  );
};
